import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'formdata-polyfill';
import 'whatwg-fetch';
import React from 'react';
import { setRegionPrefixToFetch } from 'security/src/FetchUtils';
import LegacyLoginWidgetRenderer from 'security/LoginWidgetRenderer';
import querystring from 'querystring';

setRegionPrefixToFetch();

export default (props) => {
    const handleLocaleSelect = (selectedLocale) => {
        if (!selectedLocale) {
            return;
        }

        const { di } = window;

        let submitUrl;

        if (di.env.isSaveLocale) {
            submitUrl = '/app/settings/savePreferredLocale';
        } else {
            submitUrl = '/app/settings/setPreferredLocale';
        }

        fetch(di.env.context + submitUrl, {
            method: 'POST',

            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },

            body: querystring.stringify({
                selectedLocale,
                CSRFToken: '',
            }),
        })
            .then((response) => {
                const contentType = response.headers.get('content-type');

                console.log(response, contentType);

                if (
                    response.status === 200 &&
                    contentType &&
                    contentType.indexOf('application/json') !== -1
                ) {
                    return response.json();
                }

                return Promise.reject();
            })
            .then((responseObject) => {
                try {
                    if (
                        responseObject &&
                        responseObject.model &&
                        responseObject.model.result === 'success'
                    ) {
                        if (di.loginLocaleUrl) {
                            window.location.replace(di.loginLocaleUrl);
                        } else {
                            window.location.reload();
                        }
                    }
                } catch (e) {
                    // Do nothing
                }
            });
    };

    return (
        <LegacyLoginWidgetRenderer
            {...props}
            onLocaleSelect={handleLocaleSelect}
        />
    );
};
